import type { BlogPostConfig } from "./types";

export const TOP_SERVISY_POST: BlogPostConfig = {
  slug: "top-servisy-transkribacii",
  metaTitle: "Западные сервисы транскрибации: почему их топы бесполезны в РФ",
  metaDescription:
    "Otter, Rev, Descript, Sonix, Happy Scribe, Notta и локальный Whisper: цены, лимиты бесплатных планов, языки и оплата из России. Разбор, почему англоязычные подборки отвечают не на ваш вопрос.",
  title: "Почему западные топы транскрибации бесполезны, если у вас русская речь и карта МИР",
  excerpt:
    "Otter, Rev, Descript, Sonix, Happy Scribe, Notta и Whisper на своём компьютере: где каждый реально силён, что скрыто в бесплатных планах и почему англоязычная подборка отвечает не на тот вопрос, с которым вы пришли.",
  category: "Обзоры",
  tags: [
    "сервисы расшифровки",
    "транскрибация аудио в текст",
    "альтернативы Otter.ai",
    "российские сервисы",
    "оплата российской картой"
  ],
  datePublished: "2026-09-01",
  dateModified: "2026-09-04",
  readingMinutes: 10,
  content: (
    <>
      <p>
        Обзоры сервисов транскрибации обычно устроены так: пятнадцать пунктов, у каждого «высокая точность» и «удобный
        интерфейс», в конце — вывод, что лучший тот, кто заплатил за размещение. Здесь будет иначе, но с оговоркой,
        которую честнее сделать сразу.
      </p>
      <p>
        Российских сервисов расшифровки — десятки: от ботов для созвонов до одностраничников с формой загрузки. Эта
        статья не рейтинг российского рынка и не попытка сказать, кто на нём лучше. Она разбирает те сервисы, которые
        обычно стоят в англоязычных топах, и отдельно объясняет, почему такой топ мало что даёт человеку с русской речью
        и картой МИР. Если вам нужен бот, который сам приходит на созвон, — это отдельный класс продуктов. Если у вас
        уже есть готовая запись — ниже три фильтра, через которые стоит прогнать любой сервис, включая наш.
      </p>

      <h2 className="mt-8 mb-4 text-2xl font-bold text-foreground">Три фильтра до того, как смотреть на фичи</h2>
      <ol className="list-decimal pl-6 space-y-1">
        <li>
          <strong>Язык.</strong> Не «поддерживается ли русский вообще», а есть ли он в официальном списке языков
          распознавания. У части известных сервисов его просто нет.
        </li>
        <li>
          <strong>Оплата.</strong> Пройдёт ли ваша карта на странице оплаты. Всё, что написано про фичи, обесценивается
          именно здесь.
        </li>
        <li>
          <strong>Задача.</strong> Живой созвон, готовая запись, монтаж видео и API для разработчика — это четыре разных
          продукта. Сравнивать их между собой по «точности» бессмысленно.
        </li>
      </ol>
      <p>
        Дальше — что каждый из западных сервисов умеет на самом деле, с ценами и лимитами с официальных страниц тарифов
        по состоянию на сентябрь 2026 года.
      </p>

      <h2 className="mt-8 mb-4 text-2xl font-bold text-foreground">
        Otter.ai — лучший, если ваши встречи на английском
      </h2>
      <p>
        Otter — самый известный сервис в категории, и заслуженно. Он не столько расшифровывает файлы, сколько живёт
        внутри рабочего дня: подключается к календарю, сам приходит ботом в Zoom, Teams и Google Meet, пишет встречу в
        реальном времени и раскидывает итоги по участникам. Как ассистент на созвонах он делает больше, чем мы.
      </p>
      <p>
        Ровно одна деталь обесценивает всё это для русскоязычного пользователя: русского языка в Otter нет. В
        официальном списке — английский, испанский, французский, немецкий, японский и китайский. Не «пока плохо
        распознаёт русский», а просто не поддерживает его. Если вы наткнулись на статью в духе «топ-10 сервисов для
        расшифровки на русском» и на первом месте там Otter — автор эту таблицу не проверял.
      </p>
      <p>
        Про бесплатный план тоже стоит сказать честно, потому что именно за него Otter обычно и хвалят. 300 минут в
        месяц звучит щедро, пока не дочитаешь строчку рядом: не длиннее 30 минут на одну встречу и{" "}
        <strong>три импорта файла за всё время существования аккаунта</strong> — не в месяц, а всего. То есть загрузить
        готовую запись вы сможете три раза, и на этом бесплатный план для вашей задачи закончится. Платный Pro — $16,99
        в месяц при помесячной оплате, около $8,33 в месяц при годовой.
      </p>

      <h2 className="mt-8 mb-4 text-2xl font-bold text-foreground">Rev — когда нужен живой человек, а не модель</h2>
      <p>
        Rev — редкий случай, когда сервис честно продаёт не алгоритм, а людей. За $1,99 за минуту запись расшифровывает
        человек и вычитывает её глазами. Это дорого — час записи стоит около $120 — но для судебного заседания,
        врачебного приёма или интервью, которое пойдёт в печать под вашей фамилией, машинная расшифровка с любой
        точностью всё равно потребует вычитки. Rev просто делает эту вычитку за вас и берёт за неё деньги.
      </p>
      <p>
        Если вам нужен документ, за который кто-то несёт ответственность, ни один автоматический сервис, включая наш,
        Rev не заменит. Автоматическая расшифровка у самого Rev тоже есть, на бесплатном плане — 45 минут в месяц,
        подписки начинаются примерно от $25 за место. Русский Rev поддерживает; $10,49 за минуту — это не расшифровка, а
        отдельная услуга: субтитры на русском, сделанные человеком.
      </p>

      <h2 className="mt-8 mb-4 text-2xl font-bold text-foreground">Descript — это вообще не транскрибатор</h2>
      <p>
        Descript регулярно попадает в подборки сервисов транскрибации, и это недоразумение. Descript — видеомонтажка, в
        которой ролик режут, удаляя слова из текста расшифровки. Транскрипт там не результат, а интерфейс к таймлайну.
      </p>
      <p>
        Если вы монтируете подкаст или видео и хотите вырезать все «э-э-э» одной кнопкой — берите Descript, мы для этой
        задачи не подходим вообще. Если вам нужен текст встречи, чтобы прочитать и разослать, вы платите за монтажный
        комбайн, которым не пользуетесь: бесплатный план даёт всего 1 час медиа в месяц, дальше — от $16 в месяц за 10
        часов.
      </p>

      <h2 className="mt-8 mb-4 text-2xl font-bold text-foreground">Sonix, Happy Scribe, Notta — середина рынка</h2>
      <p>
        Три похожих сервиса, каждый со своей арифметикой. Sonix продаёт почасово: $10 за час без подписки, 30 минут на
        пробу, подписка Core — $25 в месяц за 5 часов. Happy Scribe устроен так же, но в евро: пробник на 10 минут,
        Basic около €8,50 в месяц за 120 минут, доплата €0,20 за минуту сверх лимита, и отдельно живая расшифровка
        человеком от €1,75 за минуту.
      </p>
      <p>
        Notta — самый показательный пример того, как читают бесплатные планы. «120 минут в месяц бесплатно» выглядит
        нормально ровно до строчки «максимум 3 минуты на одну запись». Три минуты. Ни одна встреча, лекция или интервью
        в этот лимит не помещается, то есть бесплатный план физически не позволяет сделать ту задачу, ради которой вы
        пришли. Это не обман — это воронка. Платный Pro — около $13,60 в месяц за 1800 минут, точная цифра зависит от
        того, платите вы помесячно или за год.
      </p>
      <p>Все три поддерживают русский и все три работают прилично. И все три упираются в кассу — об этом ниже.</p>

      <h2 className="mt-8 mb-4 text-2xl font-bold text-foreground">Что умеют западные сервисы</h2>
      <p>
        Цены и лимиты — с официальных страниц тарифов, сверено в сентябре 2026 года. Тарифы у всех меняются, так что
        перед покупкой проверяйте на сайте сервиса.
      </p>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr>
              <th className="border border-border px-3 py-2 text-sm">Сервис</th>
              <th className="border border-border px-3 py-2 text-sm">Основная задача</th>
              <th className="border border-border px-3 py-2 text-sm">Что даёт бесплатно</th>
              <th className="border border-border px-3 py-2 text-sm">Платный вход</th>
              <th className="border border-border px-3 py-2 text-sm">Русский язык</th>
              <th className="border border-border px-3 py-2 text-sm">Оплата картой РФ</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-border px-3 py-2 text-sm">Otter.ai</td>
              <td className="border border-border px-3 py-2 text-sm">Бот на встречу, запись в реальном времени</td>
              <td className="border border-border px-3 py-2 text-sm">
                300 мин/мес, но 30 мин на встречу и 3 импорта файла за всё время
              </td>
              <td className="border border-border px-3 py-2 text-sm">$16,99/мес, ~$8,33/мес при годовой оплате</td>
              <td className="border border-border px-3 py-2 text-sm">Нет</td>
              <td className="border border-border px-3 py-2 text-sm">Напрямую — нет</td>
            </tr>
            <tr>
              <td className="border border-border px-3 py-2 text-sm">Rev</td>
              <td className="border border-border px-3 py-2 text-sm">Расшифровка человеком под ответственность</td>
              <td className="border border-border px-3 py-2 text-sm">45 мин/мес автоматической расшифровки</td>
              <td className="border border-border px-3 py-2 text-sm">от ~$25/мес; человек — $1,99/мин</td>
              <td className="border border-border px-3 py-2 text-sm">Да</td>
              <td className="border border-border px-3 py-2 text-sm">Напрямую — нет</td>
            </tr>
            <tr>
              <td className="border border-border px-3 py-2 text-sm">Descript</td>
              <td className="border border-border px-3 py-2 text-sm">Монтаж видео и подкастов по тексту</td>
              <td className="border border-border px-3 py-2 text-sm">1 час медиа в месяц</td>
              <td className="border border-border px-3 py-2 text-sm">от $16/мес за 10 часов</td>
              <td className="border border-border px-3 py-2 text-sm">Да</td>
              <td className="border border-border px-3 py-2 text-sm">Напрямую — нет</td>
            </tr>
            <tr>
              <td className="border border-border px-3 py-2 text-sm">Sonix</td>
              <td className="border border-border px-3 py-2 text-sm">Файл → текст</td>
              <td className="border border-border px-3 py-2 text-sm">30 мин на пробу</td>
              <td className="border border-border px-3 py-2 text-sm">$10/час или $25/мес за 5 часов</td>
              <td className="border border-border px-3 py-2 text-sm">Да</td>
              <td className="border border-border px-3 py-2 text-sm">Напрямую — нет</td>
            </tr>
            <tr>
              <td className="border border-border px-3 py-2 text-sm">Happy Scribe</td>
              <td className="border border-border px-3 py-2 text-sm">Файл → текст, субтитры</td>
              <td className="border border-border px-3 py-2 text-sm">10 мин на пробу</td>
              <td className="border border-border px-3 py-2 text-sm">от ~€8,50/мес за 120 мин</td>
              <td className="border border-border px-3 py-2 text-sm">Да</td>
              <td className="border border-border px-3 py-2 text-sm">Напрямую — нет</td>
            </tr>
            <tr>
              <td className="border border-border px-3 py-2 text-sm">Notta</td>
              <td className="border border-border px-3 py-2 text-sm">Файл → текст, запись встреч</td>
              <td className="border border-border px-3 py-2 text-sm">120 мин/мес, но максимум 3 мин на запись</td>
              <td className="border border-border px-3 py-2 text-sm">~$13,60/мес за 1800 мин</td>
              <td className="border border-border px-3 py-2 text-sm">Да</td>
              <td className="border border-border px-3 py-2 text-sm">Напрямую — нет</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        Обходные пути для оплаты существуют — зарубежная карта, посредники, подарочные коды. Но это уже не «выбрать
        сервис транскрибации», это отдельный проект с комиссией и риском потерять доступ к оплаченной подписке в любой
        момент. Дальше в статье они не рассматриваются.
      </p>

      <h2 className="mt-8 mb-4 text-2xl font-bold text-foreground">
        Whisper на своём компьютере — честный ноль рублей
      </h2>
      <p>
        Модель Whisper от OpenAI выложена в открытый доступ, её можно запустить локально и расшифровывать сколько угодно
        бесплатно. Это не лазейка и не серая схема, это нормальный рабочий вариант, и мы не будем делать вид, что его не
        существует.
      </p>
      <p>
        Стоит он не денег, а времени. Нужна видеокарта (на процессоре час записи может считаться дольше самого часа),
        установка окружения, отдельное решение для разделения по спикерам — в Whisper диаризации нет из коробки, её
        прикручивают сторонними библиотеками. Плюс придётся самому разбираться с известным поведением модели: на тишине
        и на не-речевом аудио Whisper склонен дописывать текст, которого в записи не было.
      </p>
      <p>
        Простое правило: если вы умеете и любите настраивать окружение, а записей у вас много — считайте, что вы уже
        нашли лучший вариант, дальше можно не читать. Если слово «окружение» вызывает раздражение, это решение обойдётся
        вам дороже подписки.
      </p>

      <h2 className="mt-8 mb-4 text-2xl font-bold text-foreground">
        Что доступно с российской картой: не рейтинг, а четыре полки
      </h2>
      <p>
        Здесь мы намеренно не строим турнирную таблицу. Российских решений много, у половины есть «независимые
        сравнения», где на первом месте стоят они сами, — участвовать в этом жанре смысла нет. Полезнее другое:
        понимать, что рынок делится не на «лучше и хуже», а на четыре разные работы. Выберите полку, а конкретный сервис
        на ней проверяйте на своей записи, а не по чужой таблице точности.
      </p>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr>
              <th className="border border-border px-3 py-2 text-sm">Полка</th>
              <th className="border border-border px-3 py-2 text-sm">Когда это ваш вариант</th>
              <th className="border border-border px-3 py-2 text-sm">Чем платите</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-border px-3 py-2 text-sm">Боты для созвонов</td>
              <td className="border border-border px-3 py-2 text-sm">
                Нужно, чтобы сервис сам пришёл в Zoom, Meet или Teams, писал в реальном времени и рассылал итоги
              </td>
              <td className="border border-border px-3 py-2 text-sm">Подписка в рублях</td>
            </tr>
            <tr>
              <td className="border border-border px-3 py-2 text-sm">Файл или ссылка → текст</td>
              <td className="border border-border px-3 py-2 text-sm">
                Запись уже есть, нужны спикеры, таймкоды, выжимка, выгрузка в DOCX или SRT
              </td>
              <td className="border border-border px-3 py-2 text-sm">Минуты или подписка в рублях</td>
            </tr>
            <tr>
              <td className="border border-border px-3 py-2 text-sm">Облачные API (Яндекс, Сбер)</td>
              <td className="border border-border px-3 py-2 text-sm">
                Вы разработчик и встраиваете распознавание в свой продукт, вам нужны SLA и документация
              </td>
              <td className="border border-border px-3 py-2 text-sm">Оплата по потреблению, нужен код</td>
            </tr>
            <tr>
              <td className="border border-border px-3 py-2 text-sm">Локальная модель на своём железе</td>
              <td className="border border-border px-3 py-2 text-sm">
                Записи не должны покидать компьютер, объёмы большие, настройка не пугает
              </td>
              <td className="border border-border px-3 py-2 text-sm">0 ₽ + время и видеокарта</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        Polotno стоит на второй полке. Она плотная: там не двое и не трое, и делать вид, что после отсева западных
        сервисов остаёмся мы, было бы враньём. Просто эта статья отвечает на другой вопрос — почему англоязычный топ вам
        не помогает.
      </p>

      <h2 className="mt-8 mb-4 text-2xl font-bold text-foreground">
        Как отличить сервис, который закроется через полгода
      </h2>
      <p>
        Транскрибация — самая простая ниша для запуска: страница, форма загрузки, кнопка «расшифровать». Поэтому новые
        сервисы появляются почти каждые пару недель, и большая часть из них живёт ровно до того момента, пока основателю
        не надоест их кормить из своего кармана. Публичные «кладбища» закрытых AI-продуктов — это уже отдельный жанр
        списков, и транскрибаторы там занимают заметную долю.
      </p>
      <p>Признаки, по которым стоит насторожиться:</p>
      <ol className="list-decimal pl-6 space-y-1">
        <li>
          <strong>Облачный безлимит без оплаты пользователем.</strong> Каждая минута распознавания стоит сервису денег:
          это чужие серверы и вычисления. Если вы не платите и лимитов нет — платит инвестор или основатель, и это
          заканчивается. Оговорка: локальная модель на вашем железе и бесплатные тарифы больших экосистем живут по
          другой экономике, это не тот случай.
        </li>
        <li>
          <strong>Нет реквизитов и оферты.</strong> Если на сайте нельзя понять, кому вы платите, значит, предъявить
          претензию будет некому.
        </li>
        <li>
          <strong>Нет способа написать живому человеку.</strong> Форма обратной связи, которая никуда не ведёт, —
          надёжный признак, что поддержки нет и не планировалось.
        </li>
        <li>
          <strong>Кроме формы загрузки на сайте больше ничего нет.</strong> Нет оферты, нет выгрузки в нормальный
          формат, нет способа написать человеку, нет понятной цены на следующий месяц. Такой сервис держится, пока
          основателю не надоест его кормить.
        </li>
      </ol>
      <p>
        Проверять это стоит и на нас: у Polotno указаны реквизиты и оферта, поддержка отвечает в Telegram живым текстом,
        а бесплатного безлимита нет сознательно — 99 ₽ за 150 минут это не жадность, а способ оплачивать расшифровки из
        выручки, а не из чьего-то кармана. Возраст сервиса сам по себе ничего не доказывает, поэтому мы им и не
        размахиваем.
      </p>

      <h2 className="mt-8 mb-4 text-2xl font-bold text-foreground">Чего в Polotno нет</h2>
      <p>
        Раз уж мы разбираем чужие слабые места, честно про свои. У нас нет расшифровки в реальном времени: мы работаем с
        готовой записью, а не с идущим прямо сейчас звонком. У нас нет бота, который сам приходит в Zoom или Teams и
        пишет встречу за вас, — запись надо сделать средствами самой конференции и загрузить файлом или ссылкой. Нет
        интеграций с трекерами задач и календарём. Нет мобильного приложения, есть веб и Telegram-бот с общим балансом.
      </p>
      <p>
        Всё это технически добавляется, и не за год. Вопрос всегда один и тот же: будет ли за это кто-то платить, или мы
        просто наплодим функций, которыми никто не пользуется, и переложим их стоимость в подписку тех, кому нужен был
        только текст встречи. Пока мы выбираем второе не делать. Если вам не хватает именно этого — напишите в
        поддержку, такие письма мы считаем.
      </p>

      <h2 className="mt-8 mb-4 text-2xl font-bold text-foreground">Когда мы вам не подходим</h2>
      <ul className="list-disc pl-6 space-y-1">
        <li>Нужен бот, который сам сидит на созвоне и пишет его вживую — это другая полка, не наша.</li>
        <li>Нужен текст, за который кто-то несёт юридическую ответственность, — это Rev или живой стенографист.</li>
        <li>Записи не должны покидать ваш компьютер — только локальная модель.</li>
        <li>Нужен корпоративный API с SLA под встройку в свой продукт — вам в облако Яндекса или Сбера.</li>
      </ul>
      <p>
        А если вам нужно ровно то, что мы делаем — взять готовую запись на русском, получить текст с разделением по
        спикерам и таймкодами, выжимку и файл в TXT, DOCX или SRT, заплатив рублями, — то проверять это на чужой
        подборке необязательно. Загрузите одну свою запись и посмотрите на результат.
      </p>
    </>
  ),
  faq: [
    {
      question: "Почему западные сервисы транскрибации не подходят пользователям из России?",
      answer:
        "По двум причинам сразу. Otter.ai не поддерживает русский язык вообще — в списке английский, испанский, французский, немецкий, японский и китайский. Rev, Descript, Sonix, Happy Scribe и Notta русский умеют, но напрямую картой российского банка их оплатить нельзя. Обходные пути через зарубежные карты и посредников существуют, но добавляют комиссию и риск потерять доступ к оплаченной подписке."
    },
    {
      question: "Как выбрать сервис транскрибации, если у меня русская речь и российская карта?",
      answer:
        "Сначала определите задачу, а не ищите общий рейтинг. Живой созвон с ботом в Zoom, готовая запись в текст, облачный API для разработчика и локальная модель на своём компьютере — это четыре разных продукта, сравнивать их между собой по точности бессмысленно. Внутри нужной полки проверяйте сервис на своей записи: оплату в рублях, оферту и реквизиты, живую поддержку, экспорт в нужный формат."
    },
    {
      question: "Есть ли действительно бесплатные сервисы транскрибации?",
      answer:
        "Бесплатные планы есть почти у всех, но они рассчитаны на то, чтобы вы не смогли выполнить реальную задачу: у Otter — 3 импорта файла за всё время существования аккаунта, у Notta — не длиннее 3 минут на запись, у Descript — 1 час медиа в месяц. По-настоящему бесплатный вариант один: локальный Whisper, где вы платите не деньгами, а временем на настройку и требованиями к железу."
    },
    {
      question: "Сколько стоит расшифровать час записи?",
      answer:
        "У зарубежных сервисов около $10 за час у Sonix без подписки и около $120 за час у Rev, если расшифровывает человек. В Polotno час стоит примерно 45 ₽ на тарифе Профи, около 80 ₽ на Базовом и 150 ₽ при оплате минутами без подписки."
    },
    {
      question: "Почему у Polotno нет бесплатного тарифа?",
      answer:
        "Каждая минута распознавания стоит сервису денег — это чужие серверы и вычисления, поэтому облачный безлимит без оплаты пользователем означает, что расходы покрывает инвестор или основатель — и это заканчивается вместе с сервисом. Пробный период за 99 ₽ на 150 минут даёт полноценно проверить качество на своих записях, а не на трёхминутном отрывке."
    },
    {
      question: "Чего Polotno не умеет?",
      answer:
        "Нет расшифровки в реальном времени и бота, который сам подключается к звонку: мы работаем с уже готовой записью. Нет интеграций с календарём и трекерами задач и нет мобильного приложения — есть веб-версия и Telegram-бот с общим балансом минут. Для юридически значимой расшифровки нужен человек, для полностью закрытых записей — локальная модель."
    }
  ],
  relatedPaths: ["/transcription-online", "/mp3-to-text", "/speaker-diarization", "/meeting-minutes", "/audio-summary"],
  extraJsonLd: [
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "Сервисы транскрибации, разобранные в статье",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Otter.ai", url: "https://otter.ai" },
        { "@type": "ListItem", position: 2, name: "Rev", url: "https://www.rev.com" },
        { "@type": "ListItem", position: 3, name: "Descript", url: "https://www.descript.com" },
        { "@type": "ListItem", position: 4, name: "Sonix", url: "https://sonix.ai" },
        { "@type": "ListItem", position: 5, name: "Happy Scribe", url: "https://www.happyscribe.com" },
        { "@type": "ListItem", position: 6, name: "Notta", url: "https://www.notta.ai" },
        { "@type": "ListItem", position: 7, name: "Whisper (OpenAI)", url: "https://github.com/openai/whisper" },
        { "@type": "ListItem", position: 8, name: "Polotno", url: "https://polotno.tech" }
      ]
    }
  ]
};
